(function() {
  function initBlogsCarousel(sectionId, displayMode, mobileCarousel) {
    var $section = $('.featured-blogs[data-section-id="' + sectionId + '"]');
    var $carousel = $section.find('.featured-blogs__owl');
    var $prevBtn = $section.find('[data-blogs-prev]');
    var $nextBtn = $section.find('[data-blogs-next]');

    if ($carousel.length === 0) return;

    // Initialize Owl Carousel
    $carousel.owlCarousel({
      items: 4,
      loop: true,
      margin: 24,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      smartSpeed: 600,
      mouseDrag: true,
      touchDrag: true,
      dots: false,
      nav: false,
      responsive: {
        0: {
          items: 1,
          margin: 16,
          stagePadding: 30
        },
        576: {
          items: 2,
          margin: 16,
          stagePadding: 0
        },
        900: {
          items: 3,
          margin: 20
        },
        1200: {
          items: 4,
          margin: 24
        }
      }
    });

    // Wire up nav buttons
    $prevBtn.on('click', function() {
      $carousel.trigger('prev.owl.carousel');
    });
    $nextBtn.on('click', function() {
      $carousel.trigger('next.owl.carousel');
    });

    // Handle mobile-only carousel
    if (!displayMode || displayMode === 'grid') {
      var wasCarousel = false;
      function checkMobileCarousel() {
        var isMobile = window.innerWidth <= 768;
        if (mobileCarousel && isMobile && !wasCarousel) {
          $carousel.addClass('owl-carousel').owlCarousel('refresh');
          wasCarousel = true;
        } else if (!isMobile && wasCarousel) {
          wasCarousel = false;
        }
      }
      $(window).on('resize', checkMobileCarousel);
      checkMobileCarousel();
    }
  }

  // Initialize for all featured blogs sections
  function initAllBlogsCarousels() {
    $('.featured-blogs[data-section-id]').each(function() {
      var $section = $(this);
      var sectionId = $section.data('section-id');
      var displayMode = $section.data('display-mode');
      var mobileCarousel = $section.data('mobile-carousel');

      if (displayMode === 'carousel' || mobileCarousel) {
        initBlogsCarousel(sectionId, displayMode, mobileCarousel);
      }
    });
  }

  if (typeof jQuery !== 'undefined') {
    $(document).ready(function() {
      initAllBlogsCarousels();
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      var checkJQuery = setInterval(function() {
        if (typeof jQuery !== 'undefined') {
          clearInterval(checkJQuery);
          initAllBlogsCarousels();
        }
      }, 100);
    });
  }
})();
